<template>
<div>
    <div v-if="printerIP">
      <button   @click="setPrint('PRECONTO',props)"  class="btn btn-warning float-right">
        <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
        STAMPA PRECONTO   
    </button>
    </div>
    <div v-else>
    <button v-if="printBtn" @click="printPreviewReceipt(props)"  class="btn btn-light float-right">
        <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
        STAMPA PRECONTO    
    </button>
    </div>

</div>
</template>
<script>


import PreviewReceipt      from '@/components/mixins/PreviewReceipt.js'
import receiptHeader       from '@/components/mixins/ReceiptHeading.js'
import setPrint            from '@/epson/xml.js'
import JSPM                from 'jsprintmanager'
export default {
   mixins  : [PreviewReceipt,receiptHeader,setPrint],
   props   : ['props'],

 data() {
        return {     

            printerIP  : '',
            printBtn   : false

        }
    },
  async created()
  {
    
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    this.printBtn = JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open
    this.printerIP = JSON.parse(localStorage.getItem("printerIP"))     
    
  },

}
</script>


